import { ICellRendererParams, ICellRendererComp } from 'ag-grid-community';

export class DescriptionCellComponent implements ICellRendererComp {
  public cell: HTMLElement;

  public init(params: ICellRendererParams) {
    this.cell = document.createElement('div');

    if (params.valueFormatted) {
      this.populateComponent(params.valueFormatted);
    }
  }

  public getGui() {
    return this.cell;
  }

  public refresh(params: ICellRendererParams): boolean {
    if (params.valueFormatted) {
      this.populateComponent(params.valueFormatted);
    } else {
      this.cell.innerHTML = '';
    }
    return true;
  }

  private populateComponent(value: string) {
    this.cell.innerHTML = `<div title="${value}" style="overflow-x: hidden; text-overflow: ellipsis;">${value}</div>`;
  }
}
